import { Tag } from '@carbon/react';
import { EventRenderer } from 'components/event-renderer';
import type { EventActivityItem } from './types';
import style from './activity-item.module.scss';

interface EventActivityProps {
  item: EventActivityItem;
}

export const EventActivity = ({ item }: EventActivityProps) => {
  const { data, createdAt, actionTag, details } = item;

  return (
    <li className={style.activityItem}>
      <EventRenderer
        kind={data.kind}
        createdBy={data.createdBy}
        createdAt={createdAt}
        payload={data.payload}
        details={details}
        contentClassName={style.content}
        contentPrefix={
          actionTag && (
            <Tag type={actionTag.color} size="sm">
              {actionTag.label}
            </Tag>
          )
        }
      />
    </li>
  );
};
